import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import { GoogleTagManager, sendGTMEvent } from '@next/third-parties/google';
import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { BASE_URL } from '@/constants/apiUrls';
var createHashId = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(id) {
    var encoder, data, hasBuffer;
    return _regenerator().w(function (_context) {
      while (1) {
        switch (_context.n) {
          case 0:
            encoder = new TextEncoder();
            data = encoder.encode(id);
            _context.n = 1;
            return window.crypto.subtle.digest('SHA-256', data);
          case 1:
            hasBuffer = _context.v;
            return _context.a(2, Array.from(new Uint8Array(hasBuffer)).map(function (b) {
              return b.toString(16).padStart(2, '0');
            }).join(''));
        }
      }
    }, _callee);
  }));
  return function createHashId(_x) {
    return _ref.apply(this, arguments);
  };
}();
var TagManager = function TagManager() {
  var _process$env$NEXT_PUB;
  var router = useRouter();
  var _useState = useState(null),
    userHash = _useState[0],
    setUserHash = _useState[1];
  useEffect(function () {
    var fetchUserData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var response, data, _t;
        return _regenerator().w(function (_context2) {
          while (1) {
            switch (_context2.n) {
              case 0:
                _context2.n = 1;
                return fetch(BASE_URL + '/profile', {
                  credentials: 'include'
                });
              case 1:
                response = _context2.v;
                if (!response.ok) {
                  _context2.n = 4;
                  break;
                }
                _context2.n = 2;
                return response.json();
              case 2:
                data = _context2.v;
                _t = setUserHash;
                _context2.n = 3;
                return createHashId(data.id);
              case 3:
                _t(_context2.v);
              case 4:
                return _context2.a(2);
            }
          }
        }, _callee2);
      }));
      return function fetchUserData() {
        return _ref2.apply(this, arguments);
      };
    }();
    fetchUserData();
  }, []);

  // Get phase & slug from stored back-end data to send to GTM
  var _useSelector = useSelector(function (state) {
      var apiData = state.apiData;
      var entities = apiData.entities;
      if (entities !== null && entities !== void 0 && entities.settings && Object.keys(entities.settings).length > 0) {
        var settings = entities.settings;
        var projectUrl = Object.keys(settings)[0];
        var parts = projectUrl.split('/');
        return [settings[projectUrl].phase, parts[0]];
      }
      return [];
    }),
    _useSelector2 = _slicedToArray(_useSelector, 2),
    currentPhase = _useSelector2[0],
    projectSlug = _useSelector2[1];

  // Resend GTM pageview event when phase, projectSlug or route changes
  useEffect(function () {
    if (currentPhase && projectSlug) {
      sendGTMEvent({
        event: 'pageview',
        phase: currentPhase,
        projectName: projectSlug,
        referrer: router.asPath,
        userId: userHash || 'anonymous'
      });
    }
  }, [currentPhase, projectSlug, router.asPath]);
  return __jsx(GoogleTagManager, {
    gtmId: (_process$env$NEXT_PUB = process.env.NEXT_PUBLIC_GTM_KEY) !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : '',
    dataLayer: ['phase', 'projectName'],
    "data-id": "components_TagManager_GoogleTagManager"
  });
};
export default TagManager;